import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/reportes/creditosAlumno';
import ReporteCreditosAlumno from './CreditosAlumno';


const ms2p = (state) => {
    return {
        ...state.creditosAlumno,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ReporteCreditosAlumno);
